import { useLocation } from "react-router-dom";
import ContentHeader from "../../../../../layout/ContenteHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDiagramProject } from "@fortawesome/free-solid-svg-icons";

const darken = (hex, amount = 0.45) => {
  const clean = hex.replace("#", "");
  const num = parseInt(clean, 16);
  const r = Math.round(((num >> 16) & 0xff) * amount);
  const g = Math.round(((num >> 8) & 0xff) * amount);
  const b = Math.round((num & 0xff) * amount);
  return "#" + [r, g, b].map((x) => x.toString(16).padStart(2, "0")).join("");
};

const ProjectsHeader = ({ project, color: colorProp, logoUrl }) => {
  const url = useLocation();
  const isIndex = url.pathname === "/project/";
  const title = isIndex ? "Projects" : `Project: ${project?.title || ""}`;
  const subtitle = isIndex ? "Manage and track your ongoing work" : "Project details and progress";
  const color = colorProp || project?.color || "#1a73e8";
  const hasLogo = !isIndex && !!logoUrl;
  const iconBg = isIndex
    ? "linear-gradient(135deg, #1a73e8 0%, #1a237e 100%)"
    : `linear-gradient(135deg, ${color} 0%, ${darken(color)} 100%)`;
  const shadow = isIndex
    ? "0 4px 12px rgba(26,115,232,0.3)"
    : `0 4px 12px ${color}66`;

  return (
    <ContentHeader>
      <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
        <div style={{
          width: "46px",
          height: "46px",
          borderRadius: "12px",
          background: hasLogo ? "#f5f5f5" : iconBg,
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "1.2rem",
          flexShrink: 0,
          boxShadow: shadow,
          overflow: "hidden",
        }}>
          {hasLogo
            ? <img src={logoUrl} alt="logo" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
            : <FontAwesomeIcon icon={faDiagramProject} />
          }
        </div>
        <div>
          <div style={{ fontSize: "1.5rem", fontWeight: 800, color: "#212121", lineHeight: 1.2 }}>
            {title}
          </div>
          <div style={{ fontSize: "0.85rem", color: "#9e9e9e", marginTop: "2px" }}>
            {subtitle}
          </div>
        </div>
      </div>
    </ContentHeader>
  );
};

export default ProjectsHeader;
